 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		68: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		68: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"buybox~stylequiz~super-sku","7":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"aisle-bay~buybox","11":"bath-renovation~orange-lens","12":"buybox~promotion-products-lazy","13":"buybox~quick-view","14":"compare~overlay","15":"promotion-products-lazy~quick-view","16":"promotion-products-lazy~ratings-and-reviews","17":"ratings-and-reviews-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"common","31":"compare","32":"consumer-card-messaging","33":"customer-image-overlay","34":"drawer","35":"emt-generated-content","36":"emt-links","37":"emt-questions-and-answers-component","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"orange-lens","50":"order-sample","51":"order-sample-drawer","52":"overlay","53":"paint-reorder","54":"paint-reorder-mobile","55":"pep","56":"pep-mobile","57":"product","58":"product-mobile","59":"product-overview","60":"promotion-products-lazy","61":"question","62":"questions-and-answers","63":"quick-view","64":"ratings-and-reviews","65":"ratings-and-reviews-desktop","66":"results","67":"returns-messaging","69":"share-to-email-overlay","70":"share-to-pinterest-overlay","71":"size-guide-overlay","72":"specifications","73":"stylequiz","74":"super-sku","75":"vendor-collection-products","76":"vendor-collections","77":"vendor-collections-mobile","79":"video-player","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"92333c3cc21c21e66dd8","1":"4722548126851cb8fc84","2":"8bbd4c65874c8890029b","3":"d822f31290e0fafd14a4","4":"bafa88fd28aabec3d0b6","5":"57fca8e8daa185487d0a","6":"7ca2aedaa75e36ff9a5f","7":"2641126794ead5b6b93c","8":"0c52640abbbc41b85685","9":"e7850fe945caed6ecfe7","10":"10f3b6777ada828943af","11":"4c87491716eeb88f7bfc","12":"044fd7f690300a48275c","13":"05b0fc3db8a4ce2deed4","14":"0aecbdd3e0024461a0ea","15":"264b022f3eda79ed7998","16":"e3e709c5f090c1ddad81","17":"62d8dc373a3467e2bcc2","18":"efa11cf221deae0b0666","19":"8868c61c253591b51982","20":"61698df4890699c33e6c","21":"63c2fdf27e5674ab9083","22":"8b7ba5ba02ea12533e5d","23":"8d12904d527554809157","24":"deb5a58f2f424ec051d4","25":"e69eef714c3a9c287116","26":"e9979e0b39475209081e","27":"1c21d6cc94ff80d210ec","28":"0e03d45a388d19886b98","29":"ce9bda1e663a9cf146d2","30":"8d0f641454299e70bab7","31":"e3b7a4846080c5f603f7","32":"0a25c0a6e26306f6edd7","33":"a8e79822d722440fd181","34":"baa9d5fb8dde2accfdb5","35":"c96901c687eaa0d7e14f","36":"2be0729611deb1021cb5","37":"da5a5c61d16baf0be836","38":"3e33606a5b8b9dbdf334","39":"0f59fe91e60c5bf7d07b","40":"ec8825588e5c82558c94","42":"d29a503c1c55d2f343fa","43":"191d755cd9fe37f21b8a","44":"401d84d87cb5fd8802f3","45":"1f95d0cbefb709d7f8c4","46":"bcdf9a31b362430695b0","47":"802477a240b1fa1a6775","48":"5c98886787a54e6b8fbe","49":"7af5adf492e697a523c8","50":"9a5257d44e8633baba8b","51":"8b7e585b6496f4eb0f2f","52":"03b5407463eb8e98a87b","53":"a4e48910cbc70f3ba1a6","54":"30f9dfc2f720c9b703d8","55":"1f27e02631463c440dee","56":"06c027d02a8cb41e7d97","57":"b5112bc0ef57571c9f47","58":"01210e5b01efcbc9ea2e","59":"2c38f12f05e3c069d8b2","60":"32a73b8aab3acf1e6156","61":"789dc81e32c07a15e68e","62":"73bdb3f9a7ecce71d770","63":"880a56def5a90cf29da0","64":"790f8cae6c60f4895523","65":"5eae6f4ce1ec9b563757","66":"e0b56d7df17f9e569678","67":"0883511ca1999d01f782","69":"9d1987ba398454aede1e","70":"9e05d287c93b4cd94c95","71":"12ffa1088c1f3a3f8d49","72":"3ef2de73f7b4302f15de","73":"8813086a2acd0fa71eed","74":"52a2c9434aea13ca28b0","75":"b9df2d9b8b5b8fd6637a","76":"6a4470fb08137516babe","77":"884240bd49335a027bf1","79":"6d51985d2af12ceda4a5","80":"e43ee51d7174741dc5ac","81":"0cad11102ad90dc144c7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"13":1,"14":1,"16":1,"17":1,"20":1,"24":1,"25":1,"26":1,"28":1,"29":1,"31":1,"32":1,"33":1,"34":1,"35":1,"38":1,"39":1,"43":1,"46":1,"47":1,"48":1,"52":1,"53":1,"54":1,"55":1,"56":1,"57":1,"58":1,"59":1,"60":1,"62":1,"63":1,"71":1,"73":1,"74":1,"75":1,"76":1,"77":1,"79":1,"80":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gall~23d9e305","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~or~ddb78501","2":"add-to-list-drawer~bath-renovation~browse-and-search~browse-and-search-mobile~collections~collection~8f8db49f","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~media-gallery-overlay~medi~bd43bb1c","4":"media-gallery-overlay~media-gallery-overlay-mobile~orange-lens~stylequiz","5":"promotion-products-lazy~ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","6":"buybox~stylequiz~super-sku","7":"media-gallery-overlay~media-gallery-overlay-mobile~stylequiz","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"add-to-list-drawer~magic-apron","10":"aisle-bay~buybox","11":"bath-renovation~orange-lens","12":"buybox~promotion-products-lazy","13":"buybox~quick-view","14":"compare~overlay","15":"promotion-products-lazy~quick-view","16":"promotion-products-lazy~ratings-and-reviews","17":"ratings-and-reviews-mobile","18":"StoreLayout","19":"add-to-list-drawer","20":"aisle-bay","21":"augmented-reality","22":"bath-renovation","23":"breadcrumbs","24":"browse-and-search","25":"browse-and-search-mobile","26":"buybox","27":"calculator-pipcalculator","28":"collections","29":"collections-mobile","30":"common","31":"compare","32":"consumer-card-messaging","33":"customer-image-overlay","34":"drawer","35":"emt-generated-content","36":"emt-links","37":"emt-questions-and-answers-component","38":"fbr","39":"global-custom-configurator","40":"hammerjs","42":"home","43":"magic-apron","44":"measurement-guide","45":"measurement-guide-overlay-content","46":"media-gallery-filmstrip-mobile","47":"media-gallery-overlay","48":"media-gallery-overlay-mobile","49":"orange-lens","50":"order-sample","51":"order-sample-drawer","52":"overlay","53":"paint-reorder","54":"paint-reorder-mobile","55":"pep","56":"pep-mobile","57":"product","58":"product-mobile","59":"product-overview","60":"promotion-products-lazy","61":"question","62":"questions-and-answers","63":"quick-view","64":"ratings-and-reviews","65":"ratings-and-reviews-desktop","66":"results","67":"returns-messaging","69":"share-to-email-overlay","70":"share-to-pinterest-overlay","71":"size-guide-overlay","72":"specifications","73":"stylequiz","74":"super-sku","75":"vendor-collection-products","76":"vendor-collections","77":"vendor-collections-mobile","79":"video-player","80":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"2134e3f2525f4b18b82f","2":"31d6cfe0d16ae931b73c","3":"dc0bc626ca15ffc94f61","4":"89d9163eeb30e835d559","5":"fd5b0df9636559fa8ba8","6":"20f2aced33e6b1ed7b41","7":"0ef658ad0521bc70e648","8":"65f1d7aedc445dc5836f","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"88078be229242eb84276","14":"9f6e95f53122c35ea62a","15":"31d6cfe0d16ae931b73c","16":"9d02d79dc9b8f52f7762","17":"2ade42f7647d0b013747","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"d94b956aa532c1a50c65","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"42652601ff0ae779858b","25":"766c85efdd2e5fc7d70f","26":"03a17a550cca64bbf44f","27":"31d6cfe0d16ae931b73c","28":"c49844a226a77e90a9b0","29":"89ba1d0098cbe24392b9","30":"31d6cfe0d16ae931b73c","31":"e1f63ff090d5f96e31b4","32":"b71f8ffaebe49e5b8650","33":"32b2ceba1e4cfc936c08","34":"fc73174b407ad863c497","35":"b49004ddac99adec2224","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"88e24c7aafcf93ae6cc6","39":"1a5562a08d12f7682989","40":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"4be99b2862037eff2a09","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"a3d0306b84dd9d80e2af","47":"3a42c68bf5a478e99c01","48":"47afbd20419a0f96b611","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"3eae282145055105039e","53":"fc650b263badee2304d6","54":"cff893f31bdad17e93fc","55":"745a3c4f0d536aa13161","56":"5163fb2f93ed403c3fdf","57":"d5c3e568275445a5f820","58":"2161c8acb169092cf314","59":"be155bb5d11dacdc4bb8","60":"3d0034667fc7d24314e6","61":"31d6cfe0d16ae931b73c","62":"d70c859b20e57c1599c5","63":"6f9a26c7879287c63284","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"453dfc2640779a848cc6","72":"31d6cfe0d16ae931b73c","73":"69a51d0e555e98d06a0d","74":"b31101625f385d3bcc30","75":"e518e335254638969e62","76":"96acad5d779f9ce0b6c5","77":"760fc5b79894c2224a24","79":"24ab350a8a93783bfec6","80":"8fa58144c65ae4d5868b","81":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
